import { common } from './common';
import { error } from './error';
import { footer } from './footer';
import { groupManagement } from './groupManagement';
import { landingPage } from './landingPage';
import { loading } from './loading';
import { login } from './login';
import { notifications } from './notifications';
import { onboarding } from './onboarding';
import { prayerStream } from './prayerStream';
import { userAgreement } from './userAgreement';

export const esUs = {
  common,
  error,
  footer,
  groupManagement,
  landingPage,
  loading,
  login,
  notifications,
  onboarding,
  prayerStream,
  userAgreement,
} as const;
